/// Opportunity record. Mirrors the `opportunities` table. Monetary columns
/// arrive as decimal strings to preserve precision through JSON.
export type OpportunityStatus =
  | 'prospect'
  | 'qualified'
  | 'proposal'
  | 'negotiation'
  | 'won'
  | 'lost';

export const OPPORTUNITY_STATUS_LABELS: Record<OpportunityStatus, string> = {
  prospect: '見込み',
  qualified: 'QC済',
  proposal: '提案',
  negotiation: '交渉',
  won: '受注',
  lost: '失注',
};

/// Opportunity のレスポンスモデル (`Opportunity` / `Paged<Opportunity>`) は #471 で
/// `domain/opportunity/model.ts` (branded) へ移設。 API レスポンスは
/// `parseOpportunity` を通すこと。

export interface OpportunityListQuery {
  q?: string;
  firm_id?: string;
  lawyer_id?: string;
  status?: OpportunityStatus;
  sort_by?: 'name' | 'status' | 'expected_close_on' | 'created_at' | 'updated_at';
  sort_dir?: 'asc' | 'desc';
  page?: number;
  page_size?: number;
}

export interface OpportunityCreateRequest {
  firm_id: string;
  name: string;
  probability?: string | null;
  primary_lawyer_id?: string | null;
  is_individual_contract?: boolean;
  main_interest_lawyer_id?: string | null;
  individual_contract_memo?: string | null;
  /** 担当者 (assignee, multi; ACC-4)。app_accounts(id) の配列。 */
  assignee_account_ids?: string[];
  expected_monthly_amount?: string | null;
  expected_initial_amount?: string | null;
  billing_model?: string | null;
  started_on?: string | null;
  expected_close_on?: string | null;
  next_action?: string | null;
  next_action_due_at?: string | null;
  current_problem?: string | null;
  expected_effect?: string | null;
  decision_maker?: string | null;
  decision_process?: string | null;
  desired_start_date?: string | null;
}

export interface OpportunityPatchRequest {
  firm_id?: string;
  name?: string;
  probability?: string | null;
  primary_lawyer_id?: string | null;
  is_individual_contract?: boolean;
  main_interest_lawyer_id?: string | null;
  individual_contract_memo?: string | null;
  /** 担当者を置換 (multi; ACC-4)。空配列 = 全クリア。省略で据え置き。 */
  assignee_account_ids?: string[];
  expected_monthly_amount?: string | null;
  expected_initial_amount?: string | null;
  confirmed_monthly_amount?: string | null;
  billing_model?: string | null;
  started_on?: string | null;
  expected_close_on?: string | null;
  closed_on?: string | null;
  next_action?: string | null;
  next_action_due_at?: string | null;
  current_problem?: string | null;
  expected_effect?: string | null;
  decision_maker?: string | null;
  decision_process?: string | null;
  desired_start_date?: string | null;
}

export interface TransitionOpportunityRequest {
  next_status: OpportunityStatus;
  reason?: string | null;
  comment?: string | null;
}
